import React from 'react';
import PropTypes from 'prop-types';

import { getUserFields } from '../../helpers/UserFields';

const UserProfileFields = ({ profile }) => {
  const userFields = getUserFields(profile)
    .filter(uf => (!['phone', 'job_title'].includes(uf.role)))
    .filter(uf => (uf.value));

  if (userFields.length === 0) {
    return null;
  }

  return (
    <div className="user-profile-fields">
      <ul className="user-profile-fields-list">
        {userFields.map(userField => (
          <li key={userField.id} className="user-profile-fields-item">
            <h5>{userField.name}</h5>
            <p>{userField.value}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

UserProfileFields.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfileFields;
